/*
  Minicar — Cart Bridge
  Définit le custom element cart-notification AVANT que product-form.js s'exécute.
  Ce script est chargé dans le <head> SANS defer, donc il s'exécute en premier.
*/
(function() {
  'use strict';

  if (customElements.get('cart-notification')) return;

  class McdCartBridge extends HTMLElement {
    constructor() {
      super();
    }

    // Méthode appelée par product-form.js pour obtenir les sections à re-rendre
    getSectionsToRender() {
      return [];
    }

    // Méthode appelée par product-form.js après un ATC réussi
    renderContents(parsedState) {
      // Ouvrir le drawer Minicar (défini dans minicar-cart-drawer.liquid)
      if (typeof window.mcdOpenCart === 'function') {
        window.mcdOpenCart();
        if (typeof window.mcdShowToast === 'function') {
          window.mcdShowToast('\u2705 Ajouté au panier !');
        }
      } else {
        // Fallback si le drawer n'est pas encore initialisé
        setTimeout(function() {
          if (typeof window.mcdOpenCart === 'function') {
            window.mcdOpenCart();
            if (typeof window.mcdShowToast === 'function') {
              window.mcdShowToast('\u2705 Ajouté au panier !');
            }
          }
        }, 200);
      }
    }

    // Méthodes requises par product-form.js
    setActiveElement(element) {
      this._activeElement = element;
    }
  }

  customElements.define('cart-notification', McdCartBridge);

})();
